import Action from './Action';

export default Action;